import { useEffect } from 'react';

import EnsureLoggedInContainer from '@/components/EnsureLoggedIn/EnsureLoggedInContainer';
import { PaymentProviders } from '@/enums';
import { useAppDispatch } from '@/redux/hooks';
import { openAddCreditCardModal } from '@/redux/modules/modal';

import AddCreditCardPageHeaderMeta from './AddCreditCardPageHeaderMeta';

const AddCreditCardPage = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(openAddCreditCardModal(PaymentProviders.Payrix));
    }, [dispatch]);

    return (
        <EnsureLoggedInContainer>
            <div className="mb-[70px] flex flex-col">
                <AddCreditCardPageHeaderMeta />
            </div>
        </EnsureLoggedInContainer>
    );
};

export default AddCreditCardPage;
